import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, OnDestroy, OnInit, Output} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {FormControl, FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {InnRegistrationService} from './inn-registration.service';

@Component({
    selector: 'app-inn-registration',
    template: `
        <form [formGroup]="form" (submit)="save(form)">
            <p>Укажите ИНН организации и система автоматически заполнит большинство реквизитов организации</p>
            <app-form-group [fbControl]="form.get('INN')">
                <app-form-label>ИНН</app-form-label>
                <app-form-input [fbControl]="form.get('INN')" inputmask="legalInn"></app-form-input>
            </app-form-group>
            <p class="form-message-info">Не помню ИНН. <a href="javascript:;" (click)="cancelInn.emit()">Перейти к заполнению формы</a></p>
            <app-button [disabled]="!isInnValid" [pending]="isPending" className="button-green">
                Проверить данные
            </app-button>
        </form>
    `,
})

export class InnRegistrationComponent extends FrontendFormComponent implements OnDestroy {

    @Output() cancelInn = new EventEmitter();
    @Output() successInnCheck = new EventEmitter<object>();

    public isInnValid = false;

    form = new FormGroup({
        INN: new FormControl(''),
    });

    private subs: Subscription[] = [];

    constructor(
        injector: Injector,
        public formService: InnRegistrationService,
    ) {
        super(injector);
    }

    init() {
        this.checkInnValidity(this.form.get('INN').value);
        this.form.get('INN').valueChanges.subscribe((value) => this.checkInnValidity(value));
    }

    private checkInnValidity(value: string) {
        this.isInnValid = value.length === 10 && value.indexOf('_') < 0;
    }

    preventSave() {
        return !this.isInnValid;
    }

    saveHandler(formData: object) {
        this.successInnCheck.emit(formData);
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    /**
     * Отключаем уведомление об ошибках в полях, переопределяя родительский метод
     * @param error
     * @returns {null}
     */
    showErrorsNotification(error) {
        return null;
    }
}
